import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
// BUI overrides - apply Material UI styling to Backstage UI components
import './styles/bui-overrides.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
